var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_47598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.078125,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_47598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_2",
    d: "M15.0787 16.3179L8.73734 22.6592C8.56428 22.8323 8.34674 22.9208 8.08472 22.9248C7.82272 22.9289 7.60118 22.8403 7.42009 22.6592C7.23899 22.4781 7.14844 22.2586 7.14844 22.0006C7.14844 21.7426 7.23899 21.5231 7.42009 21.342L13.7614 15.0006L7.42009 8.65922C7.24701 8.48616 7.15847 8.26861 7.15447 8.00659C7.15045 7.74459 7.23899 7.52305 7.42009 7.34197C7.60118 7.16086 7.82072 7.07031 8.07872 7.07031C8.33672 7.07031 8.55626 7.16086 8.73734 7.34197L15.0787 13.6833L21.4201 7.34197C21.5932 7.16889 21.8107 7.08034 22.0727 7.07634C22.3347 7.07232 22.5563 7.16086 22.7373 7.34197C22.9184 7.52305 23.009 7.74259 23.009 8.00059C23.009 8.25859 22.9184 8.47813 22.7373 8.65922L16.396 15.0006L22.7373 21.342C22.9104 21.515 22.999 21.7326 23.003 21.9946C23.007 22.2566 22.9184 22.4781 22.7373 22.6592C22.5563 22.8403 22.3367 22.9309 22.0787 22.9309C21.8207 22.9309 21.6012 22.8403 21.4201 22.6592L15.0787 16.3179Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/closeX.9dfbd6e2fb4ec0511eebd1a773f7a6cb.svg";
export { ForwardRef as ReactComponent };